export default {
  setHeaders(){
    const accessToken = localStorage.ACCESS_TOKEN
    return  {
      headers: {
        Authorization: `Bearer ${accessToken}`
      },
    }
  },
  getPayloadString(params: object){
    return  Object.entries(params).map(e => e.join('=')).join('&');
  },
}